module.exports = __webpack_public_path__ + "08c8cac1718dd27f1b4a02d011754863.png";